








































































































































































import Vue from 'vue';
import i18n from 'vue-i18n';
import CoLoadingIndicator from '../../Atoms/co-loading-indicator/coLoadingIndicator.vue';
import CoText from '../../Atoms/co-text/CoText.vue';

Vue.use(i18n);

let nextOtpId = 0;
function getNextOtpId() {
    nextOtpId += 1;
    return nextOtpId;
}

export default {
    name: 'CoOtpVerification',
    components: {
        CoLoadingIndicator,
        CoText,
    },
    props: {
        email: {
            type: String,
            required: true,
        },
        codeLength: {
            type: Number,
            default: 6,
            validator(value: number) {
                return value > 0;
            },
        },
        loading: {
            type: Boolean,
            default: false,
        },
        resendLoading: {
            type: Boolean,
            default: false,
        },
        statusMessage: {
            type: String,
            default: '',
        },
        resendAvailableAt: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            code: '',
            inputFocused: false,
            now: Date.now(),
            countdownInterval: null as ReturnType<typeof setInterval> | null,
            submissionLocked: false,
            otpId: getNextOtpId(),
        };
    },
    computed: {
        inputId() {
            return `co-otp-code-${this.otpId}`;
        },
        messageId() {
            return `co-otp-message-${this.otpId}`;
        },
        secondsUntilResend() {
            return Math.max(0, Math.ceil((this.resendAvailableAt - this.now) / 1000));
        },
        countdown() {
            const minutes = String(Math.floor(this.secondsUntilResend / 60)).padStart(2, '0');
            const seconds = String(this.secondsUntilResend % 60).padStart(2, '0');
            return `${minutes}:${seconds}`;
        },
    },
    watch: {
        resendAvailableAt() {
            this.now = Date.now();
        },
        loading(value: boolean) {
            this.$nextTick(() => {
                // Removing the focused input must not send keyboard users behind the dialog.
                if (value) this.$el.closest('[role="dialog"]')?.focus();
                else if (this.code.length < this.codeLength) this.focus();
            });
        },
    },
    mounted() {
        // Focus after insertion so modal users can type the first digit immediately.
        this.$nextTick(this.focus);
        // The timestamp comes from the concrete flow, so a successful resend can restart this reusable countdown.
        this.countdownInterval = setInterval(() => {
            this.now = Date.now();
        }, 1000);
    },
    beforeDestroy() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    },
    methods: {
        focus() {
            const input = this.$refs.input as HTMLInputElement;
            input?.focus();
        },
        handleInput(event: InputEvent) {
            const input = event.target as HTMLInputElement;
            const nextCode = input.value.replace(/\D/g, '').slice(0, this.codeLength);
            input.value = nextCode;
            this.code = nextCode;
            this.$emit('input', nextCode);

            if (nextCode.length < this.codeLength) {
                this.submissionLocked = false;
                return;
            }
            if (!this.submissionLocked && !this.loading) {
                this.submissionLocked = true;
                this.$emit('submit', nextCode);
            }
        },
        requestResend() {
            if (this.secondsUntilResend === 0 && !this.loading && !this.resendLoading) {
                this.$emit('resend');
            }
        },
        resetCode() {
            this.code = '';
            this.submissionLocked = false;
            this.$nextTick(this.focus);
        },
    },
};
